import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";
import Avatar from "react-avatar";

import { KioskAppLogoSvgIcon } from "@components/SvgIcons";
import { syncStore } from "@components/Synchronization/store";

export default function LocalSettingHeader(): JSX.Element {
    const { selectedShopApp, connectedUser } = useSnapshot(syncStore);
    return (
        <div
            style={{
                display: "grid",
                height: "14rem",
                width: "100%",
                position: "relative",
                gridTemplateColumns: "2fr 3fr",
                gridTemplateRows: "1fr",
                background: "linear-gradient(135deg, #1f2937 0%, #111827 100%)",
                borderRadius: "20px 20px 0px 0px",
                padding: "1.5rem 2rem",
                overflow: "hidden",
                boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.1)",
                border: "1px solid #374151",
            }}
        >
            {/* Background accent */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background:
                        "linear-gradient(90deg, #077dbc 0%, #065a94 50%, #077dbc 100%)",
                }}
            />

            <div
                className="d-flex justify-content-center align-items-center"
                style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    marginLeft: "40px",
                    gap: 70,
                }}
            >
                <div
                    style={{
                        padding: "1rem",
                        background: "rgba(255, 255, 255, 0.05)",
                        borderRadius: "16px",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        backdropFilter: "blur(10px)",
                    }}
                >
                    <KioskAppLogoSvgIcon width="300" height="125" />
                </div>

                {/* Separator */}
                <div
                    style={{
                        height: "125px",
                        width: "1px",
                        background:
                            "linear-gradient(to bottom, transparent, #4b5563, transparent)",
                    }}
                />
            </div>

            <div
                className="d-flex justify-content-center align-items-center"
                style={{ gap: 50, marginBottom: "10px" }}
            >
                <div className="d-flex flex-column" style={{ gap: "12px" }}>
                    {/* Greeting */}
                    <div
                        className="d-flex"
                        style={{
                            color: "#ffffff",
                            fontSize: "24px",
                            fontWeight: "600",
                            textAlign: "left",
                            letterSpacing: "0.5px",
                            fontFamily: "Segoe UI, sans-serif",
                            textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
                            gap: "10px",
                        }}
                    >
                        <span>{t("Hello")}</span>
                        {connectedUser.firstName ? (
                            <span
                                className="text-capitalize"
                                style={{
                                    color: "#65b6d5",
                                }}
                            >
                                {`${connectedUser.firstName}`}
                            </span>
                        ) : null}
                        !
                    </div>

                    {/* Shop name */}
                    <div
                        style={{
                            color: "#d1d5db",
                            fontSize: "16px",
                            fontWeight: "400",
                            textAlign: "left",
                            letterSpacing: "0.5px",
                            fontFamily: "Segoe UI, sans-serif",
                            opacity: 0.9,
                        }}
                    >
                        {selectedShopApp.name as string}
                    </div>

                    {/* Status indicator */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            padding: "8px 16px",
                            background: "rgba(34, 197, 94, 0.1)",
                            border: "1px solid rgba(34, 197, 94, 0.3)",
                            borderRadius: "25px",
                            backdropFilter: "blur(10px)",
                            width: "fit-content",
                        }}
                    >
                        {/* Status dot */}
                        <div
                            style={{
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor: "#22c55e",
                                border: "1px solid rgba(255, 255, 255, 0.3)",
                                animation:
                                    "statusPulse 2s ease-in-out infinite",
                            }}
                        />

                        {/* Status text */}
                        <div
                            style={{
                                color: "#ffffff",
                                fontSize: "13px",
                                fontWeight: "500",
                                letterSpacing: "0.3px",
                                fontFamily: "Segoe UI, sans-serif",
                            }}
                        >
                            votre borne est à jour
                        </div>
                    </div>
                </div>

                {/* Avatar */}
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        padding: "4px",
                        background: "rgba(255, 255, 255, 0.1)",
                        borderRadius: "50%",
                        border: "2px solid rgba(101, 182, 213, 0.3)",
                        backdropFilter: "blur(10px)",
                    }}
                >
                    <Avatar
                        email={connectedUser.email as string}
                        name={connectedUser.firstName as string}
                        size="70px"
                        round={true}
                    />
                </div>
            </div>

            {/* CSS Animations */}
            <style>{`
        @keyframes statusPulse {
            0%, 100% { 
                opacity: 1;
                transform: scale(1);
            }
            50% { 
                opacity: 0.7;
                transform: scale(1.1);
            }
        }
    `}</style>
        </div>
    );
}
